/**
 * Ищем контейнер
 * @param target
 * @returns {*}
 */
function findContainer(target) {
	if (!target) return false;
	return document.querySelector(target)
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

/**
 * Приводим в порядок типы данных
 * @param value
 * @returns {any}
 */
function normalizeData(value)  {
	if (value === 'true') {
		return true
	}

	if (value === 'false') {
		return false
	}

	if (value === Number(value).toString()) {
		return Number(value)
	}

	if (value === '' || value === 'null') {
		return null
	}

	if (typeof value !== 'string') {
		return value
	}

	try {
		return JSON.parse(decodeURIComponent(value))
	} catch {
		return value
	}
}

export {findContainer, getDataAttributes, normalizeData}